export default function TermsOfUsePage() {
    return (
        <>
            <div className="hero">
                <div className="container">
                    <h1 className="hero-title">Termos de Uso</h1>
                    <p className="hero-description hero-description-wide">
                        Orientações rápidas para acesso e utilização do site e da plataforma
                        LineXS ERP
                    </p>
                </div>
            </div>
            <section className="section pt-0">
                <div className="container container-narrow">
                    <p>
                        <strong>Leonardo Valcarenghi Desenvolvimento de Software LTDA.</strong>{" "}
                        (“Linexs”), CNPJ 61.116.573/0001-70, na qualidade de proprietária do
                        domínio <a href="https://linexs.com.br">www.linexs.com.br</a> e do
                        respectivo conteúdo, bem como da plataforma LineXS ERP (
                        <a href="https://erp.linexs.com.br">erp.linexs.com.br</a>), apresenta
                        aqui os
                        <strong>Termos de Uso</strong> relativos aos seus sites e plataformas. A
                        utilização dos sites, plataformas ou conteúdos neles disponibilizados
                        sujeita o usuário ao cumprimento das condições aqui estabelecidas.
                    </p>
                    <p>
                        O site da Linexs (<a href="https://linexs.com.br">www.linexs.com.br</a>)
                        tem como objetivo apresentar aos clientes e ao público em geral
                        informações sobre o software LineXS ERP, incluindo suas funcionalidades,
                        benefícios e informações institucionais da empresa. A plataforma LineXS
                        ERP (<a href="https://app.linexs.com.br">app.linexs.com.br</a>) é um
                        software voltado à gestão integrada de empresas, oferecendo ferramentas
                        para administração de processos financeiros, vendas, contratos,
                        produtos, clientes e demais funcionalidades do sistema.
                    </p>
                    <p>
                        É expressamente proibida a reprodução, comercialização, publicação ou
                        distribuição, total ou parcial, de informações, materiais, textos,
                        gráficos, marcas ou quaisquer outros conteúdos dos sites ou da
                        plataforma da LineXS ERP, sem autorização prévia e por escrito.
                    </p>
                    <p>
                        Os textos informativos produzidos pelos colaboradores da Linexs têm
                        caráter meramente educativo e informativo, não devendo ser considerados
                        como aconselhamento legal, contábil ou profissional de qualquer
                        natureza.
                    </p>
                    <p>
                        A LineXS ERP poderá oferecer serviços especiais ou customizados a seus
                        clientes, disponíveis em áreas restritas da plataforma, que estarão
                        sujeitos à assinatura de termos específicos.
                    </p>
                    <p>
                        A Linexs, em nenhuma hipótese, será responsável por danos ou prejuízos
                        decorrentes do uso das informações disponíveis nos sites ou na
                        plataforma, nem pela utilização dos sistemas pelos usuários.
                    </p>
                    <p>
                        A Linexs não se responsabiliza por conteúdos de terceiros, incluindo
                        sites externos aos quais haja links disponíveis nos sites ou na
                        plataforma.
                    </p>
                    <p>
                        O acesso aos sites da LineXS ERP é anônimo, permitindo que o usuário
                        visualize todas as informações disponíveis sem necessidade de
                        identificação prévia.
                    </p>
                    <p>
                        Os sites e a plataforma LineXS ERP não utilizam cookies para coleta de
                        informações pessoais ou de navegação. No entanto, provedores externos
                        poderão coletar dados genéricos e não pessoalmente identificáveis para
                        fins estatísticos.
                    </p>
                    <p>
                        Os presentes Termos de Uso podem ser atualizados a qualquer momento,
                        independentemente de aviso prévio. Esta página sempre apresentará a
                        versão mais atualizada e vigente dos Termos de Uso. Ao acessar os sites
                        e a plataforma, o usuário estará automaticamente sujeito aos Termos de
                        Uso em vigor no momento do acesso.
                    </p>
                </div>
            </section>
        </>


    )
}